/* eslint-disable camelcase */
import { useState } from "react";
import { Button, Card } from "@hireart/component-library";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import {
  getMetaContent,
  indiscriminatelyCombineFlashMessages,
} from "../../Common/helpers/meta";
import { FormError } from "./FormError";

const Login = ({ session }) => {
  const [error] = useState("");
  const [loading] = useState(false);

  let flash;
  if (session) {
    flash = session.flash;
  }

  let oauthError = "";

  if (flash && flash.flashes && Object.keys(flash.flashes).length > 0) {
    oauthError = indiscriminatelyCombineFlashMessages(flash.flashes);
  }

  const makingRequest = loading;

  const googleAuthUrlFragment = `/saml_providers/tripadvisor-entra`;

  return (
    <Card className="rounded-0 border-0 px-24 py-32 sm:rounded-16 sm:border-1">
      <h2 className="headline-1 mb-24 text-center">Welcome to HireArt.</h2>

      <FormError error={error || oauthError} />

      <form action={googleAuthUrlFragment} method="post">
        <input
          type="hidden"
          name="authenticity_token"
          value={getMetaContent("csrf-token")}
        />
        <Button
          color="secondary"
          isFullWidth
          isDisabled={makingRequest}
          type="submit"
        >
          <span className="inline-flex items-center gap-8">
            <img
              alt=""
              className="inline h-20 w-20"
              src="/assets/entra-icon.svg"
            />
            Sign in with Entra
          </span>
        </Button>
      </form>
    </Card>
  );
};

Login.propTypes = {
  session: PropTypes.shape({
    flash: PropTypes.shape({
      flashes: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
    }),
  }),
};

Login.defaultProps = {
  session: null,
};

const mapDispatchToProps = ({ session }) => ({ session });

const LoginSSO = connect(mapDispatchToProps)(Login);
export { LoginSSO };
